import { RoleItemTable, SiteData, SiteDetail } from 'src/types/siteData';
export const siteData: SiteData = {
  organization_id: 'example_organization_id',
  organization_name: 'example_organization_name',
  site_list: [
    {
      site_id: 'XXX',
      site_name: 'クルックフィールズ',
    },
    {
      site_id: 'YYY',
      site_name: 'YYY',
    },
    {
      site_id: 'ZZZ',
      site_name: 'ZZZ',
    },
  ],
};
export const siteDetailData: SiteDetail = {
  organization_id: 'example_organization_id',
  organization_name: 'example_organization_name',
  site_id: 'example_site_id',
  site_name: 'example_site_name',

  access_point_id: 'example_access_point_id',
  acceptance_id: 'example_acceptance_id',
  area_id: 'example_area_id',
  group_id: 'example_group_id',
  peakcut_power_threshold: 100,
  is_feedback: true,
  low_high_pressure: 1,
  temperature_region_id: 'example_temperature_region_id',
  market_region_id: 'example_market_region_id',
  latitude: '35.6895',
  longitude: '139.6917',
  category: 1,
  platform_code: 1,
};
export const roleData:RoleItemTable[]=[
  {

    site_role_id: 'owner',
    
    site_role_name: 'Owner'
    
    }
]

export const siteFields = [
  {
    key: 'site_id',
    label: 'サイトID',
    sorter: true,
    _style: { textAlign: 'center',width:"50%" },
  },
  {
    key: 'site_name',
    label: 'サイト名',
    sorter: true,
    _style: { textAlign: 'center',width:"50%" },
  },
  {
    key: 'update',
    label: '更新',
    sorter: false,
    filter: false,
    _style: {
      paddingLeft: '1.5rem',
      textAlign: 'center',
      width:"75px"
    },
  },
  {
    key: 'delete',
    label: '削除',
    sorter: false,
    filter: false,
    _style: {
      paddingLeft: '1.5rem',
      textAlign: 'center',
      width:"75px"
    },
  },
];


export const rollSiteFields = [
  {
    key: 'id',
    label: 'ID',
     _style: { width: '20%' },
  },
  {
    key: 'site_role_id',
    label: 'ロールID',
    _style: { width: '40%' },
  },
  {
    key: 'site_role_name',
    label: 'ロール',
    _style: { width: '40%' },
  },
];
export const rollEditSiteFields = [
  {
    key: 'id',
    label: 'id',
    _style: { width: '10%' },
  },

  {
    key: 'site_role_id',
    label: 'ロールID',
    _style: { width: '30%' },
  },
  {
    key: 'site_role_name',
    label: 'ロール',
    _style: { width: '30%' },
  },
  {
    key: 'delete',
    label: '削除',
    _style: { width: '30%' },
  },
];
